import { Outlet } from "react-router-dom";

const CaseQA = () => {
  return <Outlet />;
};

export default CaseQA;
